// extracted by mini-css-extract-plugin
export default {"playFixBox":"index_playFixBox_0KdA4","playFix":"index_playFix_c9XaK","close":"index_close_NCcb-"};